class AurennaHeader extends HTMLElement {
  connectedCallback() {
    const button = this.querySelector('[data-menu-toggle]');
    const navigation = this.querySelector('[data-mobile-nav]');
    if (!button || !navigation) return;

    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      navigation.hidden = open;
    });
  }
}

customElements.define('aurenna-header', AurennaHeader);

function initAurennaPromoDrag(root = document) {
  if (!window.Shopify || !Shopify.designMode) return;

  root.querySelectorAll('[data-ab-promo-drag="true"]').forEach((box) => {
    if (box.dataset.abPromoDragReady === 'true') return;

    const handle = box.querySelector('[data-ab-promo-drag-handle]');
    const coordinates = box.querySelector('[data-ab-promo-drag-coordinates]');
    if (!handle || !coordinates) return;

    box.dataset.abPromoDragReady = 'true';
    let dragState = null;

    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
    const clampAndSnap = (value) => Math.max(-1000, Math.min(1000, Math.round(value / 20) * 20));

    const currentOffsets = (mobile) => ({
      x: Number(box.dataset[mobile ? 'offsetXMobile' : 'offsetX']) || 0,
      y: Number(box.dataset[mobile ? 'offsetYMobile' : 'offsetY']) || 0
    });

    const showCoordinates = (x, y) => {
      coordinates.textContent = `Horizontal ${x}px · Vertical ${y}px — copia estos valores en los controles`;
    };

    const applyPosition = (mobile, x, y) => {
      box.style.setProperty(mobile ? '--ibox-offset-x-mobile' : '--ibox-offset-x', `${x}px`);
      box.style.setProperty(mobile ? '--ibox-offset-y-mobile' : '--ibox-offset-y', `${y}px`);
      showCoordinates(x, y);
    };

    const beginDrag = (event) => {
      event.preventDefault();
      event.stopPropagation();
      const mobile = isMobile();
      const offsets = currentOffsets(mobile);
      dragState = {
        pointerId: event.pointerId,
        mobile,
        startX: event.clientX,
        startY: event.clientY,
        offsetX: offsets.x,
        offsetY: offsets.y,
        nextX: offsets.x,
        nextY: offsets.y
      };
      handle.setPointerCapture(event.pointerId);
      box.classList.add('is-dragging');
      showCoordinates(offsets.x, offsets.y);
    };

    const moveDrag = (event) => {
      if (!dragState || event.pointerId !== dragState.pointerId) return;
      event.preventDefault();
      dragState.nextX = clampAndSnap(dragState.offsetX + event.clientX - dragState.startX);
      dragState.nextY = clampAndSnap(dragState.offsetY + event.clientY - dragState.startY);
      applyPosition(dragState.mobile, dragState.nextX, dragState.nextY);
    };

    const endDrag = (event) => {
      if (!dragState || event.pointerId !== dragState.pointerId) return;
      const suffix = dragState.mobile ? 'Mobile' : '';
      box.dataset[`offsetX${suffix}`] = String(dragState.nextX);
      box.dataset[`offsetY${suffix}`] = String(dragState.nextY);
      box.classList.remove('is-dragging');
      if (handle.hasPointerCapture(event.pointerId)) handle.releasePointerCapture(event.pointerId);
      dragState = null;
    };

    handle.addEventListener('pointerdown', beginDrag);
    handle.addEventListener('pointermove', moveDrag);
    handle.addEventListener('pointerup', endDrag);
    handle.addEventListener('pointercancel', endDrag);
    handle.addEventListener('click', (event) => event.preventDefault());

    const initial = currentOffsets(isMobile());
    showCoordinates(initial.x, initial.y);
  });
}

initAurennaPromoDrag();

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('aurenna-header').forEach((element) => {
    if (!element.matches(':defined')) customElements.upgrade(element);
  });
  initAurennaPromoDrag(event.target);
});

